const items = [
  {
    icon: 'ri-brain-line',
    title: 'Inteligência Artificial Própria',
    desc: 'IA exclusiva desenvolvida especificamente para análise e cálculos trabalhistas, com aprendizado contínuo.',
  },
  {
    icon: 'ri-focus-3-line',
    title: 'Alta Precisão nos Cálculos',
    desc: 'Metodologia rigorosa e tecnologia avançada garantem resultados com 99,8% de assertividade técnica.',
  },
  {
    icon: 'ri-time-line',
    title: 'Redução de Tempo Operacional',
    desc: 'Automatização inteligente reduz drasticamente o tempo de entrega sem comprometer a qualidade.',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'Escalabilidade para Escritórios',
    desc: 'Capacidade de processar grandes volumes de demandas simultaneamente, ideal para escritórios de qualquer porte.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Segurança Técnica e Jurídica',
    desc: 'Todos os cálculos seguem rigorosamente a legislação trabalhista vigente e jurisprudência atualizada.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Suporte Especializado',
    desc: 'Equipe de peritos disponível para esclarecer dúvidas e garantir a melhor solução para cada caso.',
  },
];

export default function Diferenciais() {
  return (
    <section id="diferenciais" className="py-24 md:py-32" style={{ background: 'linear-gradient(180deg, #f0f9ff 0%, #e0f2fe 100%)' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-bold tracking-widest uppercase text-sky-500 mb-4">Por que escolher a Exato</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Diferenciais que fazem a diferença
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            Combinamos tecnologia de ponta com expertise jurídica para entregar resultados que nenhum outro serviço oferece.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item) => (
            <div
              key={item.title}
              className="bg-white rounded-2xl p-7 border border-sky-100 hover:border-sky-300 transition-all duration-200 group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl mb-5 transition-all duration-200 group-hover:scale-110"
                style={{ background: 'linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)' }}>
                <i className={`${item.icon} text-sky-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
